import { useEffect } from "react";

// Lightweight momentum smooth-scroll without extra deps.
export function useSmoothScroll() {
  useEffect(() => {
    let current = window.scrollY;
    let target = window.scrollY;
    let raf = null;
    let active = false;
    const ease = 0.09;
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (media.matches) return;

    const onWheel = (e) => {
      if (e.ctrlKey) return;
      target = Math.max(0, Math.min(target + e.deltaY, document.body.scrollHeight - window.innerHeight));
      e.preventDefault();
      if (!active) { active = true; loop(); }
    };
    const loop = () => {
      current += (target - current) * ease;
      if (Math.abs(target - current) < 0.5) { current = target; active = false; window.scrollTo(0, current); return; }
      window.scrollTo(0, current);
      raf = requestAnimationFrame(loop);
    };
    const onResize = () => { target = current = window.scrollY; };
    window.addEventListener("wheel", onWheel, { passive: false });
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("wheel", onWheel);
      window.removeEventListener("resize", onResize);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);
}
